export default {"src":"/_next/static/media/jas.da0c63e3.svg","height":73,"width":191,"blurWidth":0,"blurHeight":0};